import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Typography, Grid, Fab} from '@material-ui/core';
import { useGlobal } from 'reactn';
import { Link as RouterLink } from 'react-router-dom';
import AvatarBar from '../Components/AvatarBar.js';
import defaultImg from '../Assets/Images/takephoto.png';
import RlBadge from '../Components/Badge.js';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
const LinkBehavior = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} to="/isv" {...props} />
  ));
const useStyles = makeStyles(theme => ({
    button: {
      margin: theme.spacing(1),
    },
    input: {
      display:'none',
    },
    topBar:{
      backgroundColor: "rgba(0,0,0,.2)",
      height:"70px",
      color:"#fff"
    },
    content:{
      marginTop:"30px",
      color:'#fff',
    },
      nextBut:{
        border:"white 2px solid",
        height:"70px",
    
      },
      textInput:{color:"white"},
    /* Extras */
    a:{color:'#444',textDecoration:'none',},
      '&:visited':{color:'#888'},
    p:{marginBottom:'.3em'},
    card: {
      maxWidth: 255,
    },
    media: {
      height: 150,
    },
  }));
  export default function IsvStepThree() {
    const classes = useStyles();
    const [ global, setGlobal ] = useGlobal();

    const sendFile = (file,name) =>{
        let fdata = new FormData();
        fdata.append(name, file);
    
        fetch('https://vidensrummet.dk/vidensrumapi/uploadimage.php', {
          method: 'POST',
        headers: {
          'Accept': 'application/json',
        },
        body: fdata
      }).then(response => response.json()).then(data =>{
        
        switch(name){
            case "minecraftSs1":
              setGlobal({ minecraftmodellen: data.url });
               
            break;
            case "minecraftSs2":
              setGlobal({ minecraftudsigten: data.url });
                
            break;
            case "minecraftSs3":
              setGlobal({ minecraftSs3: data.url });
        
            break;
            default:
              alert("no valid data");
      }});
      }
      React.useEffect(()=>{
        fetch('https://vidensrummet.dk/vidensrumapi/iskalaensverdenbesoeg/update.php', {
            method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id:global.gruppeId,
            gruppemedlemmer:global.gruppemedlemmer,
            besoegsid:global.besoegsid,
            skitsemodel:global.skitsemodel,
            modulmodel:global.modulmodel,
            model:global.model,
            stopmotionvideo:global.stopmotionvideo,
            minecraftmodellen:global.minecraftmodellen,
            minecraftudsigten:global.minecraftudsigten,
            minecraftdetaljen:global.minecraftdetaljen,
          })
          }).then(response => response.json());
        },[global]);
    let firstImg = (global.minecraftmodellen==="")?defaultImg:global.minecraftmodellen;
    let secondImg = (global.minecraftudsigten==="")?defaultImg:global.minecraftudsigten;
    let thirdImg = (global.minecraftdetaljen==="")?defaultImg:global.minecraftdetaljen;
    return (
    <div>
    <AppBar position="static">
        <Toolbar>
        <Typography variant="h6" className={classes.title}>
            I skalaens verden
        </Typography>
        <AvatarBar />  
        </Toolbar>
        
    </AppBar>
    <div>
    <Grid container alignContent="flex-start" alignItems="flex-start" justify="flex-start" className={classes.content}>
        <Grid item xs={2}></Grid>
        <Grid item xs={10}>
    <Typography variant="h5">- Tag et billede af bygningen i Minecraft</Typography>
    </Grid>
    <Grid item xs={3}></Grid>
    <Grid item xs={6}>
      <label htmlFor="minecraftSs1-file">
      <RlBadge ribbonText="false" borderColor="transparent" content={<div style={{border:global.minecraftmodellen!==""?"5px solid #3D3D84":"5px solid grey",height:"219px",width:"200px",backgroundImage:"url("+firstImg+")",backgroundSize: "auto 266.79px",backgroundPosition: "center", backgroundRepeat: "no-repeat",position:"relative"}}>{global.minecraftmodellen!==""?<CheckCircleRoundedIcon fontSize="large" style={{position:"absolute",right:"-20",bottom:"-20"}}></CheckCircleRoundedIcon>:""}</div>}/>
      <div >
        </div>
      <input
    onChange={event=> {const target = event.target; if(typeof target.files[0]!== "undefined"){setGlobal({minecraftmodellen:URL.createObjectURL(target.files[0])});sendFile(target.files[0],"minecraftSs1");}}}
        accept="image/*"
        capture
        className={classes.input}
        id="minecraftSs1-file"
        type="file"
      />
        </label>
      
      </Grid>
      </Grid>
      <Grid container alignContent="flex-start" alignItems="flex-start" justify="flex-start" className={classes.content}>
      <Grid item xs={2}></Grid>
      <Grid item xs={10}>
    <Typography variant="h5">- Tag et billede af en fed detalje i Minecraft</Typography>
    </Grid>
    <Grid item xs={3}></Grid>
    <Grid item xs={6}>

      <label htmlFor="minecraftSs2-file">
      <RlBadge ribbonText="false" borderColor="transparent" content={<div style={{border:global.minecraftudsigten!==""?"5px solid #3D3D84":"5px solid grey",height:"219px",width:"200px",backgroundImage:"url("+secondImg+")",backgroundSize: "auto 266.79px",backgroundPosition: "center", backgroundRepeat: "no-repeat",position:"relative"}}>{global.minecraftudsigten!==""?<CheckCircleRoundedIcon fontSize="large" style={{position:"absolute",right:"-20",bottom:"-20"}}></CheckCircleRoundedIcon>:""}</div>}/>
      <input
    onChange={event=> {const target = event.target; if(typeof target.files[0]!== "undefined"){setGlobal({minecraftudsigten:URL.createObjectURL(target.files[0])});sendFile(target.files[0],"minecraftSs2");}}}
        accept="image/*"
        capture
        className={classes.input}
        id="minecraftSs2-file"
        type="file"
      />
    
        </label>
      
      </Grid>
      </Grid>
      <Grid container alignContent="flex-start" alignItems="flex-start" justify="flex-start" className={classes.content}>
      <Grid item xs={2}></Grid>
      <Grid item xs={10}>
    <Typography variant="h5">- Tag et billede af udsigten fra bygningen i Minecraft</Typography>
    </Grid>
    <Grid item xs={3}></Grid>
    <Grid item xs={6}>
      <label htmlFor="minecraftSs3-file">
      <RlBadge ribbonText="false" borderColor="transparent" content={<div style={{border:global.minecraftdetaljen!==""?"5px solid #3D3D84":"5px solid grey",height:"219px",width:"200px",backgroundImage:"url("+thirdImg+")",backgroundSize: "auto 266.79px",backgroundPosition: "center", backgroundRepeat: "no-repeat",position:"relative"}}>{global.minecraftdetaljen!==""?<CheckCircleRoundedIcon fontSize="large" style={{position:"absolute",right:"-20",bottom:"-20"}}></CheckCircleRoundedIcon>:""}</div>}/>
      <input
    onChange={event=> {const target = event.target; if(typeof target.files[0]!== "undefined"){setGlobal({minecraftdetaljen:URL.createObjectURL(target.files[0])});sendFile(target.files[0],"minecraftSs3");}}}
        accept="image/*"
        capture
        className={classes.input}
        id="minecraftSs3-file"
        type="file"
      />
    
        </label>

      
      </Grid>
      <Grid item xs={3} style={{marginTop:"220px"}}><Fab size="large" variant="extended" component={LinkBehavior} color="secondary" className={classes.nextBut} aria-label="add">
        <svg style={{marginRight:"8px"}}xmlns="http://www.w3.org/2000/svg" width="30px" viewBox="0 0 816.38 967.2"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1" fill="#fff"><path d="M481.09 966.37c-21 1.22-42 .85-62.93.46-40.83-.75-81.54-3.23-121.91-9.76-41.72-6.74-82.36-17-120-37-19.65-10.41-36.29-24.62-52.14-40-14-13.56-27.74-27.41-42.85-39.77a114.1 114.1 0 00-27.1-16.68c-21.64-9.36-34.19-26.82-41.82-48.36-7.53-21.25-9.84-43.43-11-65.74-1-19-.91-38-.4-57C1.7 622.81-.84 593 .3 563.17c1-24.84 3-49.51 11.88-73.09 6.6-17.58 17.81-30.56 35-39.08 32.23-16 65.58-29.16 99.17-41.85q41.51-15.66 82.8-31.89c35.05-13.86 63.15-36.49 87.07-65 38.7-46.15 65.22-98.92 85-155.42 11.11-31.84 20.41-64.32 33.04-95.64 5.92-14.7 12.72-28.95 23.25-41.06C468.83 7.12 483 .2 500.39 0c17.15-.19 33.91 1.82 49.74 8.84 27.07 12 41.57 34.24 47.89 62 11.74 51.52 9.26 102.23-9.12 152.24-14.41 39.2-31.33 77.32-47.36 115.82-7.09 17-14.65 33.91-17.77 52.29-.44 2.61-.45 5.3-.66 7.95a36 36 0 00-5 .18c-19.23 3.3-37.53 9.22-53.7 20.45-15.09 10.48-27.37 23.57-33 41.43-8.42 26.58-4.6 52.21 7.65 76.84 1.58 3.17 3.11 6.29 3.05 9.91-.21 12.63.47 25.25-.77 37.91A222.19 222.19 0 01420.8 660c-17.61 37.08-44 66.7-76.65 91.13-6.12 4.57-12.86 8.39-17.84 14.37-4 4.83-4.77 9-2.31 12.69s6.91 4.86 12.59 3.26a45.35 45.35 0 0013.1-6 271.41 271.41 0 0046.95-40c20.86-22.35 38-47.08 50.51-75 .69-1.53.91-3.57 3.24-4.43a86.15 86.15 0 0026.85 27.88c-11.17 1.48-20.49 4.39-29.13 9.32-17.41 9.93-30.42 23.61-33.89 43.92-4.23 24.79 1.65 47.58 16.37 68a69.63 69.63 0 0021.71 19.42c-11.22 3.87-19.12 10.57-25.44 19.14-12.1 16.3-13.72 35.3-11.22 54.35 4.66 35.5 26.15 56.66 60 66.19 1.86.52 4.06.36 5.45 2.13z"/><path d="M727.54 525.59c-16.6 2-33.28 3.32-49.91 5.14-29.51 3.22-58.84 7.82-88.4 10.62-23.42 2.22-46.79 3.24-70.14-.24a79.32 79.32 0 01-24.21-7.56c-13.08-6.62-21.26-16.75-22.9-31.67-1.38-12.63-1.82-25.25.71-37.75 4.33-21.35 18.41-35.19 36.05-46.24 6.51-4.08 13.55-7.09 20.42-10.45 53.13-12.38 107-12.37 161-9.51 15.62.83 31.28 1.57 46.59 5.23 27.63 6.6 42.05 23 45.17 51.36 1.24 11.35 1.23 22.63-2.4 33.62-6.9 20.92-23.06 30.83-43.16 35.91-2.87.73-5.87 1.04-8.82 1.54zM743.07 681.15c-7.27.07-14.54-.07-21.78.31-2.8.15-5.61.57-8.44.62-22.79.37-45.6.42-68.37 1.22-26.44.93-52.87 1.44-79.31 2-16.4.36-32.58-.1-48.14-5.78-24-8.74-38.69-24.9-41.12-51.21-.81-8.71-1.29-17.28 1-25.73 4.1-15.08 15.56-22.67 29.26-27.56s28-7 42.39-8.87c19.43-2.58 38.87-5 58.31-7.48q26.45-3.35 52.9-6.53 25.23-3 50.48-5.74c7.57-.81 15.18-1.2 22.77-1.78 21.61.15 41.86 4.58 59.14 18.6 29.39 23.86 36.87 82-5.1 107.71-13.51 8.32-28.4 10.86-43.99 10.22zM693.37 830.27c-17.87-1.76-35.82-2.23-53.73-3.28-22.55-1.32-45.06-3.28-67.6-4.7-17.41-1.1-34.78-2.65-52.16-4.15-27.58-2.4-49.83-13.56-62.16-39.34-7.12-14.89-9-30.73-.33-46.08 8.05-14.22 21.76-19.86 36.67-23.54 8.78-2.17 17.81-2.52 26.73-2.84 21.77-.76 43.54-1.68 65.3-2.47 34.3-1.25 68.58-.59 102.87-.67 16.12 0 32.17 1.71 48.24 2.89 4.77 1.92 9.72 3.51 14.29 5.82C774 723.32 786.32 741.39 786 767c-.35 25.29-13.54 42.4-35.68 53.25a99.57 99.57 0 01-39.45 9.69c-5.87.24-11.67.21-17.5.33zM642.16 960.88c-7.8-3.09-16.13-1.72-24.18-2.53-14-1.41-28.22-1.27-42.3-2.38-19-1.5-38.13-2.33-57.1-4.69-9.39-1.16-19.05-1.18-28.16-3.44-21.6-5.35-37.23-18.67-42.9-40.35-7.35-28.15 9.06-58.54 41.84-64.21a279.39 279.39 0 0171-3.3c7.77.65 15.58.32 23.4 1 11.74 1 23.63.3 35.36 1.36 22.29 2 44.89.51 66.9 5.75a13.52 13.52 0 003 .07l6.1 2.14c23.89 8.47 34.51 24.93 31.45 52.16-2.54 22.67-16.76 36.57-36.43 45.83-15.14 7.13-31.36 10.71-47.98 12.59z"/></g></g></svg>
        <Typography variant="h5">Næste</Typography>
      </Fab></Grid>
    </Grid>

    </div>
    </div>);
  }